(function () {
		const initManualBottomControls = (horizontalSlider, $horizontalSlider) => {
		if (!horizontalSlider || !$horizontalSlider) return;
		if (horizontalSlider.dataset.manualScrollReady === "true") return;

		horizontalSlider.dataset.manualScrollReady = "true";

		let resumeTimer = null;
		let isPointerDragging = false;
		let activePointerId = null;
		let lastPointerX = 0;
		let suppressClick = false;

		const getMarqueeAnimation = () => {
			const wrapper = horizontalSlider.querySelector(".js-marquee-wrapper");
			if (!wrapper || typeof wrapper.getAnimations !== "function") return null;
			const [animation] = wrapper
				.getAnimations()
				.filter((item) => item.playState !== "finished");
			return animation || null;
		};

		const scrubByDelta = (delta) => {
			const animation = getMarqueeAnimation();
			if (!animation || animation.currentTime == null) return false;

			animation.pause();

			const timing =
				animation.effect && typeof animation.effect.getTiming === "function"
					? animation.effect.getTiming()
					: null;
			const duration =
				timing && typeof timing.duration === "number" && isFinite(timing.duration)
					? timing.duration
					: 0;

			const scrubFactor = 35;
			let nextTime = animation.currentTime + delta * scrubFactor;

			if (duration > 0) {
				nextTime = ((nextTime % duration) + duration) % duration;
			} else {
				nextTime = Math.max(0, nextTime);
			}

			animation.currentTime = nextTime;
			return true;
		};

		const pauseAutoScroll = () => {
			$horizontalSlider.marquee("pause");
		};

		const scheduleResumeAutoScroll = () => {
			clearTimeout(resumeTimer);
			resumeTimer = setTimeout(() => {
				const animation = getMarqueeAnimation();
				if (animation && animation.playState === "paused") {
					animation.play();
				}
				$horizontalSlider.marquee("resume");
			}, 450);
		};

		horizontalSlider.addEventListener(
			"wheel",
			(event) => {
				const dominantDelta =
					Math.abs(event.deltaX) > Math.abs(event.deltaY)
						? event.deltaX
						: event.deltaY;
				if (!dominantDelta) return;
				if (!scrubByDelta(dominantDelta)) return;

				event.preventDefault();
				pauseAutoScroll();
				scheduleResumeAutoScroll();
			},
			{ passive: false },
		);

		const stopDragging = (event) => {
			if (!isPointerDragging) return;
			if (event && activePointerId !== null && event.pointerId !== activePointerId)
				return;

			isPointerDragging = false;
			activePointerId = null;
			horizontalSlider.classList.remove("aic__marquee-horizontal--dragging");
			scheduleResumeAutoScroll();
		};

		horizontalSlider.addEventListener("pointerdown", (event) => {
			if (event.pointerType === "mouse" && event.button !== 0) return;
			if (!getMarqueeAnimation()) return;

			isPointerDragging = true;
			activePointerId = event.pointerId;
			lastPointerX = event.clientX;
			suppressClick = false;

			horizontalSlider.classList.add("aic__marquee-horizontal--dragging");
			pauseAutoScroll();

			if (horizontalSlider.setPointerCapture) {
				horizontalSlider.setPointerCapture(event.pointerId);
			}
		});

		horizontalSlider.addEventListener("pointermove", (event) => {
			if (!isPointerDragging || event.pointerId !== activePointerId) return;

			const deltaX = event.clientX - lastPointerX;
			if (!deltaX) return;

			lastPointerX = event.clientX;
			if (Math.abs(deltaX) > 3) {
				suppressClick = true;
			}

			if (scrubByDelta(-deltaX)) {
				event.preventDefault();
			}
		});

		horizontalSlider.addEventListener("pointerup", stopDragging);
		horizontalSlider.addEventListener("pointercancel", stopDragging);
		horizontalSlider.addEventListener("lostpointercapture", stopDragging);

		horizontalSlider.addEventListener(
			"click",
			(event) => {
				if (!suppressClick) return;
				event.preventDefault();
				event.stopPropagation();
				suppressClick = false;
			},
			true,
		);
	};

	const initSlider = (section) => {
		let sliders, horizontalSlider, slidersWrapper;

		if (document.currentScript) {
			sliders =
				document.currentScript.parentElement.querySelectorAll(".aic__marquee");
			horizontalSlider = document.currentScript.parentElement.querySelector(
				".aic__marquee-horizontal",
			);
			slidersWrapper =
				document.currentScript.parentElement.querySelector(".aic__marquees");
		} else {
			sliders = section.querySelectorAll(".aic__marquee");
			horizontalSlider = section.querySelector(".aic__marquee-horizontal");
			slidersWrapper = section.querySelector(".aic__marquees");
		}
		const evenSliders = [];
		const oddSliders = [];

		if (sliders.length > 0) {
			sliders.forEach((slider, i) => {
				if (i % 2 === 0) {
					oddSliders.push(slider);
				} else {
					evenSliders.push(slider);
				}
			});

			oddSliders.forEach((oddSlider) => {
				if (!oddSlider.querySelector(".js-marquee-wrapper")) {
					let duration = 50000;
					if (oddSlider.closest(".aic--right")) {
						duration = 40000;
					}
					oddSlider.classList.add("marquee-down");
					const $oddSlider = $(oddSlider);
					$oddSlider.marquee({
						delayBeforeStart: 0,
						direction: "down",
						allowCss3Support: true,
						startVisible: true,
						duplicated: true,
						pauseOnHover: true,
						duration: duration,
						gap: 0,
					});
				}
			});

			evenSliders.forEach((evenSlider) => {
				if (!evenSlider.querySelector(".js-marquee-wrapper")) {
					let duration = 50000;
					if (evenSlider.closest(".aic--right")) {
						duration = 40000;
					}
					evenSlider.classList.add("marquee-up");
					const $evenSlider = $(evenSlider);
					$evenSlider.marquee({
						delayBeforeStart: 0,
						direction: "up",
						allowCss3Support: true,
						startVisible: true,
						duplicated: true,
						pauseOnHover: true,
						duration: duration,
						gap: 0,
					});
				}
			});
		}

				if (horizontalSlider) {
					const $horizontalSlider = $(horizontalSlider);
					if (!horizontalSlider.querySelector(".js-marquee-wrapper")) {
						const width = horizontalSlider.scrollWidth;
						const speed =
						document.documentElement.clientWidth > 575
						? Math.round(document.documentElement.clientWidth * 0.03)
						: Math.round(document.documentElement.clientWidth * 0.08);
					horizontalSlider.classList.add("marquee");
						$horizontalSlider.marquee({
							delayBeforeStart: 0,
							direction: "left",
						allowCss3Support: true,
						startVisible: true,
						pauseOnHover: false,
						speed: speed,
						gap: 0,
					});

				const resizeObserve = new ResizeObserver((entries) => {
					const [entry] = entries;
					const speed =
						entry.contentRect.width > 575
							? Math.round(entry.contentRect.width * 0.03)
							: Math.round(entry.contentRect.width * 0.08);
					$horizontalSlider.marquee("destroy");
						$horizontalSlider.marquee({
							direction: "left",
							allowCss3Support: true,
							startVisible: true,
							pauseOnHover: false,
							speed: speed,
							gap: 0,
						});
						});
						resizeObserve.observe(slidersWrapper);
					}

					const manualControlsEnabled = horizontalSlider.closest(
						".aic--bottom-manual-enabled",
					);
					if (manualControlsEnabled) {
						initManualBottomControls(horizontalSlider, $horizontalSlider);
					}
				}
			};

	const checkImagesLazyLoaded = () => {
		const lazyImages = document.querySelectorAll(".aic__slide img");

		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.1,
		};

		const imagesObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.removeAttribute("loading");
					observer.unobserve(entry.target);
				}
			});
		}, options);

		lazyImages.forEach((image) => {
			imagesObserver.observe(image);
		});

		const checkVisibility = () => {
			lazyImages.forEach((image) => {
				const rect = image.getBoundingClientRect();
				if (rect.top < window.innerHeight && rect.bottom > 0) {
					image.removeAttribute("loading");
				}
			});
			requestAnimationFrame(checkVisibility);
		};

		requestAnimationFrame(checkVisibility);
	};

	initSlider();
	checkImagesLazyLoaded();

	document.addEventListener("DOMContentLoaded", checkImagesLazyLoaded);

	document.addEventListener("shopify:section:load", function (section) {
		initSlider(section.target);
		checkImagesLazyLoaded();
	});
	document.addEventListener("shopify:section:reorder", function (section) {
		initSlider(section.target);
		checkImagesLazyLoaded();
	});
})();
